import { DISTRIBUTION_TYPE_ACTOR } from '../../constants/SmartInsightConstants';

export const SAVED_SEARCH_TEMPLATE = {
  entityName: '',
  searchName: '',
  showInDashboard: 0,
  viewName: '',
  isDefault: false,
  additionalConfiguration: true,
  viewRights: '',
  searchCriteria: [],
  sort: [],
  columns: [],
  actions: [],
  distribution: {
    distributionFor: DISTRIBUTION_TYPE_ACTOR,
    distributionList: [],
  },
  configuration: {
    showCriteria: false,
    showCriteriaOnNoData: true,
    openResultLinksInPortal: true,
    autoSearch: true,
    pageSize: 10,
    searchPageType: 'MULTICOLUMN_SEARCH',
    showAuditTrailLink: false,
    showInDropdown: false,
  },
};

export const REPOSITORY_SAVED_SEARCH_TEMPLATE = {
  searchCriteria: [],
  sort: [],
  columns: [],
  actions: [],
  configuration: {
    showCriteria: false,
    showCriteriaOnNoData: true,
    openResultLinksInPortal: true,
    autoSearch: true,
    pageSize: 10,
    searchPageType: 'MULTICOLUMN_SEARCH',
    showAuditTrailLink: false,
    showInDropdown: true,
  },
};
